module.exports = __webpack_public_path__ + "img/003_thelevitation.986acb43.gif";